import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Address, FloorLevel, HabitationState, HousingType, Roommate } from './types';

export const initialState: HabitationState = {
  address: null,
  step: 1,
  lastVerifiedStep: 0,
  housingType: null,
  floorLevel: null,
  roommates: [],
  numberOfRooms: 1,
  startDate: null,
  price: 0,
  paymentType: 'mensuel', 
  contractReference: null,
  stripeConfigType: null,
  subscriptionId: null,
  schoolName: null,
};


const habitationSlice = createSlice({
  name: 'habitation',
  initialState,
  reducers: {
    setAddress(state, action: PayloadAction<Address | null>) {
      state.address = action.payload;
    },
    setHousingType(state, action: PayloadAction<HousingType>) {
      state.housingType = action.payload;
    },
    setFloorLevel(state, action: PayloadAction<FloorLevel>) {
      state.floorLevel = action.payload;
    },
    setNumberOfRooms(state, action: PayloadAction<number>) {
      state.numberOfRooms = action.payload;
    },
    addRoommate(state, action: PayloadAction<Roommate>) {
      state.roommates.push(action.payload);
    },
    removeRoommate(state, action: PayloadAction<number>) {
      state.roommates.splice(action.payload, 1);
    },
    updateStartDate(state, action: PayloadAction<string>) {
      state.startDate = action.payload;
    },
    setPrice(state, action: PayloadAction<number | null>) {
      state.price = action.payload;
    },
    setPaymentType(state, action: PayloadAction<'mensuel' | 'annuel'>) {
      state.paymentType = action.payload;
    },
    setContractReference(state, action: PayloadAction<string | null>) {
      state.contractReference = action.payload;
    },
    setStripeConfigType(state, action: PayloadAction<'payment_intent' | null>) {
      state.stripeConfigType = action.payload;
    },
    setSubscriptionId(state, action: PayloadAction<string | null>) {
      state.subscriptionId = action.payload;
    },
    setSchoolName(state, action: PayloadAction<string | null>) {
      state.schoolName = action.payload;
    },
    // Navigation actions
    nextStep(state) {
      state.step += 1;
    },
    prevStep(state) {
      state.step = Math.max(state.step - 1, 1);
    },
    setStepVerified(state, action: PayloadAction<number>) {
      state.lastVerifiedStep = Math.max(state.lastVerifiedStep, action.payload);
    },
    setStep: (state, action: PayloadAction<number>) => {
      state.step = action.payload;
    },
    reset(state) {
      Object.assign(state, initialState);
    },
  },
});

export const {
  setAddress,
  setHousingType,
  setFloorLevel,
  setNumberOfRooms,
  addRoommate,
  removeRoommate,
  updateStartDate,
  setPrice,
  setPaymentType,
  setContractReference,
  setStripeConfigType,
  setSubscriptionId,
  setSchoolName,
  // Navigation actions
  nextStep,
  prevStep,
  setStepVerified,
  setStep,
  reset
} = habitationSlice.actions;

export const habitationReducer = habitationSlice.reducer;